<button mat-menu-item *ngIf="canInvite" (click)="onInvite.emit()" class="invite-btn">{{'common_invite' | translate}}</button>
<button mat-menu-item *ngIf="canCreateCourse" (click)="onCreateCourse.emit()" class="create-folder-btn">{{'folders_view-create_button' | translate}}</button>
